import { db } from "@/lib/db";
import { createSavedItemGraphics } from "@/lib/drawing-utils";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect } from "react";

/** Keeps the graphics layer in sync with the account's visible saved items. */
export function useSavedItemGraphics(graphicsLayer: GraphicsLayer | null, ownerId: string) {
    const savedItems = useLiveQuery(() => db.savedItems.where('ownerId').equals(ownerId).toArray(), [ownerId]);

    useEffect(() => {
        if (!graphicsLayer) return;
        graphicsLayer.graphics.removeAll();
        savedItems?.forEach((item) => {
            if (item.ownerId === ownerId && item.visible) graphicsLayer.graphics.addMany(createSavedItemGraphics(item));
        });
    }, [graphicsLayer, ownerId, savedItems]);
}
